import { render, staticRenderFns } from "./sendRemarks.vue?vue&type=template&id=76170f06&"
import script from "./sendRemarks.vue?vue&type=script&lang=js&"
export * from "./sendRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports